import Vue from 'vue'
import VueRouter from 'vue-router'
import app from "@/api/app";
import tools from "@/api/tools";
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/m/login',
  },
  {
    path: '/m/login',
    name: 'login',
    component: () => import('@/pages/login'),
    meta: {
      title: "登录",
    },
  },
  {
    path: '/m/order/issue',
    name: 'order.issue',
    component: () => import('@/pages/order/issue'),
    meta: {
      title: "产品出单实时播报",
    },
  },
  {
    path: '/m/personal/index',
    name: 'personal.index',
    component: () => import('@/pages/personal/index'),
    meta: {
      title: "个人中心",
    },
  },
  {
    path: '/m/order',
    name: 'order',
    redirect:'/m/order/list',
    component: () => import('@/pages/order/index'),
    children:[
      {
        path: '/m/order/list',
        name: 'order.list',
        component: () => import('@/pages/order/list'),
        meta: {
          title: "投保单",
          keepAlive: true,
        },
      },
      {
        path: '/m/order/addPolicyList',
        name: 'order.addPolicyList',
        component: () => import('@/pages/order/addPolicyList'),
        meta: {
          title: "加保记录"
        },
      },
      {
        path: '/m/order/importOrder',
        name: 'order.importOrder',
        component: () => import('@/pages/order/importOrder'),
        meta: {
          title: "关联保单"
        },
      },
      {
        path: '/m/order/importOrderList',
        name: 'order.importOrderList',
        component: () => import('@/pages/order/importOrderList'),
        meta: {
          title: "关联保单"
        },
      },
      {
        path: '/m/order/importOutsideOrder',
        name: 'order.importOutsideOrder',
        component: () => import('@/pages/order/importOutsideOrder'),
        meta: {
          title: "录入信息"
        },
      },
      {
        path: '/m/order/importOutsideOrderList',
        name: 'order.importOutsideOrderList',
        component: () => import('@/pages/order/importOutsideOrderList'),
        meta: {
          title: "录入保单"
        },
      },
      {
        path: '/m/order/importOutsideOrderDetail',
        name: 'order.importOutsideOrderDetail',
        component: () => import('@/pages/order/importOutsideOrderDetail'),
        meta: {
          title: "保单详情"
        },
      },
      {
        path: '/m/order/renewList',
        name: 'order.renewList',
        component: () => import('@/pages/order/renewList'),
        meta: {
          title: "续费管理",
          keepAlive: true,
        },
      },
      {
        path: '/m/order/visitList',
        name: 'order.visitList',
        component: () => import('@/pages/order/visitList'),
        meta: {
          title: "待回执回访保单",
        },
      },
      {
        path: '/m/order/policyDownload',
        name: 'order.policyDownload',
        component: () => import('@/pages/order/policyDownload'),
        meta: {
          title: "电子保单下载",
        },
      },
      {
        path: '/m/order/detail',
        name: 'order.detail',
        component: () => import('@/pages/order/detail'),
        meta: {
          title: "详情",
        },
      },
      {
        path: '/m/order/bzqy',
        name: 'order.bzqy',
        component: () => import('@/pages/order/bzqy'),
        meta: {
          title: "保障权益",
        },
      },
      {
        path: '/m/order/rhList',
        name: 'order.rhList',
        component: () => import('@/pages/order/rhList'),
        meta: {
          title: "人核单列表",
          keepAlive: true,
        },
      },
      {
        path: '/m/order/reVisitManage',
        name: 'order.reVisitManage',
        component: () => import('@/pages/order/reVisitManage'),
        meta: {
          title: "预约回访",
        },
      },
      {
        path: '/m/order/refund',
        name: 'order.refund',
        component: () => import('@/pages/order/refund/index'),
        meta: {
          title: "申请退保",
        },
      },

    ]

  },
  {
    path: '/m/applyInfo',
    name: 'applyInfo',
    component: () => import('@/pages/applyInfo'),
    redirect:'/m/applyInfo/info',
    children:[
      {
        path: '/m/applyInfo/info',
        name: 'applyInfo.info',
        component: () => import('@/pages/applyInfo/info'),
        meta: {
          title: "小栖快赔",
        },
      },
      {
        path: '/m/applyInfo/claimSettle',
        name: 'applyInfo.claimSettle',
        component: () => import('@/pages/applyInfo/claimSettle'),
        meta: {
          title: "我要理赔",
        }
      },
      {
        path: '/m/applyInfo/claimApplication',
        name: 'applyInfo.claimApplication',
        component: () => import('@/pages/applyInfo/claimApplication'),
        meta: {
          title: "理赔申请",
        }
      },
      {
        path: '/m/applyInfo/myClaims',
        name: 'applyInfo.myClaims',
        component: () => import('@/pages/applyInfo/myClaims'),
        meta: {
          title: "我的理赔",
        }
      },
      {
        path: '/m/applyInfo/detail',
        name: 'applyInfo.detail',
        component: () => import('@/pages/applyInfo/detail'),
        meta: {
          title: "理赔详情",
        }
      }
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})
router.afterEach((to, from, next) => {
  console.log("from", from);
  if (from.name) {
    wtsScreen.close();
  }
});
// 全局前置守卫
router.beforeEach((to, from, next) => {
  app.hideRightIcon();
  tools.setWebTitle(to.meta.title);
  next();
})

export default router
